import { asApr } from "@silo/utils";
import { MerklRewardLegacy } from "@silo/types";
import { getDepositAprMetrics } from "./utils";
import { classNames } from "../../utils/class-names";

interface DepositTotalProps {
  depositApr: bigint;
  depositRewardsApr: bigint;
  rewardsSymbol: string;
  merklRewards: MerklRewardLegacy[];
  ["data-cy"]?: string;
  isProtected: boolean;
  className?: string;
  displayProtectedAsNil?: boolean;
  revenueApr: bigint;
}

export function DepositTotal({
  depositApr,
  depositRewardsApr,
  rewardsSymbol,
  merklRewards,
  isProtected,
  ["data-cy"]: dataCy,
  className,
  displayProtectedAsNil = false,
  revenueApr,
}: DepositTotalProps): JSX.Element {
  const metrics = getDepositAprMetrics({
    depositApr,
    depositRewardsApr,
    isProtected,
    rewardsSymbol,
    merklRewards,
  });

  const hasProtectedRevenue = revenueApr > 0n;

  const hasDepositApr = metrics.hasDepositApr || hasProtectedRevenue;
  const totalDepositApr = metrics.totalDepositApr + revenueApr;

  const hasDepositIncentives =
    metrics.hasDepositRewardsApr || hasProtectedRevenue;

  if (!hasDepositApr && displayProtectedAsNil) {
    return (
      <dd
        data-cy={dataCy}
        className={classNames("font-mono font-medium", className)}
      >
        --
      </dd>
    );
  }

  return (
    <dd
      data-cy={dataCy}
      className={classNames(
        "font-mono text-2xl font-medium",
        hasDepositIncentives ? "text-amber-300" : "text-white",
        className
      )}
    >
      {hasDepositIncentives && "+"}
      {asApr(totalDepositApr)}
    </dd>
  );
}
